import { useMutation } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { AxiosError } from "axios";
import { useEffect } from "react";

import { ErrorBanner } from "@/components/Callout";
import { useEvent } from "@/components/hooks/useEvent";
import { Page } from "@/components/Page";
import { ButtonLink } from "@/components/ui/button";
import { H1, P } from "@/components/ui/typography";
import { successChargeAccount } from "@/lib/api";

export const Route = createFileRoute("/app/_sidebar-layout/add-funds/success")({
  component: HomeComponent,
  validateSearch: (search): { session_id: string } => {
    if (!search?.session_id) {
      throw Error("No session_id provided");
    }

    return {
      session_id: search?.session_id as string,
    };
  },
  head: () => ({ meta: [{ title: "Monetization Complete" }] }),
});

function HomeComponent() {
  const { session_id } = Route.useSearch();
  const mutation = useMutation({
    onError: (error: AxiosError) => console.error(error),
    mutationFn: () => successChargeAccount(session_id),
  });
  const onMount = useEvent(() => {
    mutation.mutate();
  });

  useEffect(onMount, [onMount]);

  return (
    <Page>
      <div className="max-w-[500px] w-full mx-auto flex flex-col gap-8 bg-slate-subtle p-8 border border-slate-7 dark:border-slatedark-7 rounded-lg">
        {mutation.error && <ErrorBanner error={mutation.error} />}
        <div className="flex gap-4 justify-between">
          <H1>Funds added to account!</H1>
        </div>

        <P>You can now use your funds to create campaigns.</P>
        <ButtonLink to="/app/account">Go to Account</ButtonLink>
      </div>
    </Page>
  );
}
